import React from "react";
import { t } from "ttag";

import { IProductUUID } from "../../../models/nominals";
import { useAppSelector } from "../../reducers";
import { getAllFormSubmittedForParentUUID } from "../selectors";

interface IProps {
    parentUUID: IProductUUID;
}

export const WriteReviewMultiThankYou = (props: IProps): React.ReactNode => {
    const isOpen = useAppSelector((state) =>
        getAllFormSubmittedForParentUUID(state.reviews, props),
    );

    if (!isOpen) {
        return null;
    }
    return (
        <div className="review-thank-you">
            <h2 className="review-thank-you__title">
                {t`Thank You for Writing a Review`}
            </h2>
            <p>
                {t`We appreciate your feedback and comments, and always enjoy hearing from you.`}
            </p>
            <p>
                {t`Return to the `}
                <a
                    title={t`Home`}
                    href="/"
                    className="review-thank-you__home"
                    target="_self"
                >
                    {t`homepage`}
                </a>
                <span>.</span>
            </p>
        </div>
    );
};
